/** Matches {@link CourseMaterialsDataModuleLessonItem} `contentSummary.typeName` for injected placeholder items. */
export const ADAPTIVE_AI_GENERATED_ITEM_TYPE = 'ai-generated' as const;

/**
 * Add backend GraphQL `item_type` values here as the API stabilizes so injection + outline stay in sync.
 * @see AdaptiveLearning session plan item rows
 */
export const ADAPTIVE_AI_GENERATED_ITEM_TYPE_ALIASES: readonly string[] = [
  ADAPTIVE_AI_GENERATED_ITEM_TYPE,
  'AI-GENERATED-TO-BE-DONE',
];

export const isAdaptiveAiGeneratedSessionItemType = (itemType: string | undefined): boolean =>
  itemType != null && ADAPTIVE_AI_GENERATED_ITEM_TYPE_ALIASES.includes(itemType);
